import React , {useState} from 'react'
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../../../../StyleSheet/AppComponent/InputFields/InputFields.scss";

const Repassword = (props) => {
    const {value , onChange , label , name ,Error} = props;
    const [viewpass, setViewpass] = useState(false);
    return (
        <>
            <div className='Outer-Inputs' 
            // style={{marginTop:"52px" }}
            >
                <label  style={{fontWeight:"700"}}>{label}</label>
                <div className='repassword inputFields' style={{display:"flex"}}>
                    <input type="text" value={value} onChange={onChange} name={name}   className={`${viewpass ? "activate" : "notactivate"}`} autoComplete='off'  />
                    <i className="icon iconpasswords" style={{margin:"12px", cursor:"pointer"}}>
                  {viewpass ? (
                    <RemoveRedEyeIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></RemoveRedEyeIcon>
                  ) : (
                    <VisibilityOffIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></VisibilityOffIcon>
                  )}
                </i>
                </div>
                <p style={{ color: "red",  }} className='Errors_list'>{Error}</p>
            </div>
        </>
    )
}

export default Repassword;